import DistributedChartTooltip from './distributed-chart-tooltip.component';
import { getLabel } from './utils';
export default DistributedChartTooltip;
export { getLabel };
